<template>
  <div v-show="showHome">
    <div>
      <v-col
        style="max-width: 1770px"
        class="d-flex justify-space-between mx-auto flex-wrap py-5 px-0"
      >
        <div
          @click="goToGestionTiempos"
          :disabled="!can('menu:gestiontiempos')"
          style="cursor: pointer"
          class="my-auto d-flex flex-wrap"
        >
          <ToolbarTitles :title="$tc('nav.gestionTiempos')" />
        </div>
        <v-card
          v-if="seriesLastWeek && seriesLastWeek[0] != null"
          class="pa-4 sumaHoras"
          rounded="xl"
          elevation="7"
          style="max-width: fit-content"
        >
          <p class="my-auto mr-2">
            {{ $tc("dashboard.sumaLab") }} <b>{{ addWorkingHours }}</b>
          </p>
          <p class="my-auto">
            {{ $tc("dashboard.sumaTrab") }} <b>{{ addHoursWorked }}</b>
          </p>
        </v-card>
      </v-col>

      <v-row class="mt-1">
        <v-col class="d-flex justify-center">
          <v-card class="card-estado mr-2" elevation="7">
            <v-row align="center" class="pa-2 pt-5">
              <v-col>
                <v-card-title class="py-0">
                  {{ $tc("dashboard.estado") }}
                </v-card-title>
              </v-col>

              <v-col cols="3">
                <v-menu
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateFormatted1"
                      append-icon="mdi-calendar"
                      outlined
                      dense
                      v-bind="attrs"
                      v-on="on"
                      :rules="[dateRule]"
                      hide-details="auto"
                      readonly
                      class="pr-2"
                      label="Desde"
                    />
                  </template>

                  <v-date-picker
                    v-model="date1"
                    :min="minDate"
                    :max="maxDate"
                    @input="saveDate1"
                    locale="es"
                  />
                </v-menu>
              </v-col>
            </v-row>
            <v-card-title v-if="alertState" class="d-flex justify-center">
              {{ $tc("dashboard.notDataFetch") }}
            </v-card-title>
            <canvas ref="estadoChart" class="graf1" />
          </v-card>
        </v-col>
        <v-col class="d-flex justify-center">
          <v-card class="card-grafLiq ml-2" elevation="7">
            <v-row align="center" class="pa-2 justify-space-between">
              <v-col cols="auto">
                <v-card-title class="">
                  {{ $tc("dashboard.liquidacion") }}
                </v-card-title>
              </v-col>
              <v-col class="d-flex justify-center">
                <div class="d-flex flex-wrap">
                  <span class="my-auto">
                    {{
                      liq
                        ? $tc("dashboard.liquidado")
                        : $tc("dashboard.autorizado")
                    }}
                  </span>
                  <v-switch
                    inset
                    v-model="liq"
                    class="ml-3 pa-0 ma-0 my-auto"
                    hide-details
                  />
                  <span class="my-auto">
                    {{
                      showHours ? $tc("dashboard.horas") : $tc("dashboard.dias")
                    }}
                  </span>
                  <v-switch
                    inset
                    v-model="showHours"
                    class="ml-3 pa-0 ma-0 my-auto"
                    hide-details
                  />
                </div>
              </v-col>
              <v-col cols="3">
                <v-row>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="dateFormatted2"
                        append-icon="mdi-calendar"
                        outlined
                        dense
                        v-bind="attrs"
                        v-on="on"
                        :rules="[dateRule]"
                        hide-details="auto"
                        readonly
                        label="Desde"
                        class="pr-5"
                      />
                    </template>

                    <v-date-picker
                      v-model="date2"
                      :min="minDate"
                      :max="maxDate"
                      @input="saveDate2"
                      locale="es"
                    />
                  </v-menu>
                </v-row>
              </v-col>
            </v-row>
            <v-card-title v-if="alertLiq" class="d-flex justify-center">
              {{ $tc("dashboard.notDataFetch") }}
            </v-card-title>
            <canvas ref="liqChart" class="graf1" />
          </v-card>
        </v-col>
      </v-row>
    </div>

    <v-col class="col-loading-md">
      <loader v-if="loading" :loading="loading" />
    </v-col>
  </div>
</template>

<script>
import Chart from "chart.js";
import Loader from "../Complement/Loader.vue";
import estadistics from "../../store/gestionTiempos/estadistics";
import permissions from "../mixins/permissions";
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import "chartjs-plugin-datalabels";
import moment from "moment";

export default {
  name: "Dashboard",
  mixins: [permissions],
  components: { Loader, ToolbarTitles },
  data() {
    return {
      loading: true,
      showHome: false,
      liq: false,
      showHours: false,
      estadoChartInstance: null,
      liqChartInstance: null,
      colorMap: {
        Presentes: "#2196F3",
        Ausentes: "#FF9800",
        Inconsistencias: "#4CAF50",
        HorasCaidas: "#FFC107",
        Tardes: "#8e44ad",
        Retiros: "#F44336",
        LicDias: "#009688",
        LicHoras: "#FFEB3B",
        Caidas: "#FF7F50",
        RetiroAnterior: "#87CEFA",
        Extras: "#DA70D6",
        "LICENCIA POR MA...": "#32CD32",
        "DIAS POR MUDANZ...": "#FFD700",
        "AISLAMIENTO PRE...": "#40E0D0",
        "AUSENTE POR ENF...": "#FFA07A",
        "LICENCIA POR EN...": "#20B2AA",
        "HOME OFFICE...": "#73c6b6",
        "AUSENTE...": "#FF9800",
        "ENFERMEDAD COVI...": "#00FA9A",
        "DONACION DE SAN...": "#9370DB",
        "EXCEDENCIA     ...": "#3CB371",
        "TRABAJO A DISTA...": "#BA55D3",
        "VACACIONES PERI...": "#CD5C5C",
        "ACCIDENTE DE TR...": "#1E90FF",
        "FRANCO COMPENSA...": "#F08080",
        "HS 100%        ...": "#66CDAA",
        "HCAIDAS...": "#BDB76B",
        "HS NORMALES    ...": "#f9425e",
        "HS 50%         ...": "#FF6384",
        "HS 60% NOC     ...": "#36A2EB",
        "HS AUSENTE POR ...": "#FFCE56",
        "HS FRANCO COMPE...": "#4BC0C0",
        "HS COMPENSADAS ...": "#9966FF",
        "FERIADO DIURNO ...": "#FF9F40",
        "HS 60%         ...": "#57cf4b",
        "RECARGO DE HORA...": "#8DD1E1",
        "NOLIQ...": "#FFB6C1",
        "REVISACION MEDI...": "#7d3c98",
      },
      menu1: false,
      menu2: false,
      date1: moment().format("YYYY-MM-DD"),
      date2: moment().format("YYYY-MM-DD"),
      dateFormatted1: moment().format("DD/MM/YYYY"),
      dateFormatted2: moment().format("DD/MM/YYYY"),
      alertLiq: false,
      alertState: false,
    };
  },
  async mounted() {
    await estadistics.dispatch("getItemsLastWeek");
    await estadistics.dispatch("getItemsLiquidated");
    this.loading = false;
    this.showHome = true;
    await this.renderEstadoChart();
    await this.renderLiqChart();
  },
  watch: {
    liq: "renderLiqChart",
    showHours: "renderLiqChart",
  },
  computed: {
    maxDate() {
      return moment().format("YYYY-MM-DD");
    },
    minDate() {
      return moment().subtract(2, "years").format("YYYY-MM-DD");
    },
    optionsLastWeek() {
      return estadistics.state.optionsLasWeek || {};
    },
    seriesLastWeek() {
      return estadistics.state.seriesLasWeek || [];
    },
    optionsLiqDays() {
      return estadistics.state.optionsDays || [];
    },
    seriesLiqDays() {
      return estadistics.state.serieLiqDays || [];
    },
    optionsLiqHours() {
      return estadistics.state.optionsHours || {};
    },
    seriesLiqHours() {
      return estadistics.state.serieLiqHours || [];
    },
    seriesAutHours() {
      return estadistics.state.serieAutHours || [];
    },
    seriesAutDays() {
      return estadistics.state.serieAutDays || [];
    },
    addWorkingHours() {
      return estadistics.getters.getWorkingHours;
    },
    addHoursWorked() {
      return estadistics.getters.getHoursWorked;
    },
  },
  methods: {
    async saveDate1(value) {
      this.date1 = value;
      this.dateFormatted1 = moment(value).format("DD/MM/YYYY");
      this.menu1 = false;
      await estadistics.dispatch("getItemsLastWeek", this.date1);
      await this.renderEstadoChart();
    },

    async saveDate2(value) {
      this.date2 = value;
      this.dateFormatted2 = moment(value).format("DD/MM/YYYY");
      this.menu2 = false;
      await estadistics.dispatch("getItemsLiquidated", this.date2);
      await this.renderLiqChart();
    },

    dateRule(value) {
      if (!value) return "La fecha es obligatoria";

      const selected = moment(value, "DD/MM/YYYY");
      const min = moment().subtract(2, "years");
      const max = moment();

      if (selected.isBefore(min) || selected.isAfter(max)) {
        return "La fecha no puede ser mayor a hoy ni menor a 2 años atrás";
      }

      return true;
    },

    goToGestionTiempos() {
      if (this.can("menu:gestiontiempos")) {
        this.$router.push({ path: "/GestionTiempos" });
      }
    },

    renderEstadoChart() {
      if (this.estadoChartInstance) this.estadoChartInstance.destroy();

      const labels = this.optionsLastWeek.labels || [];
      const data = this.seriesLastWeek || [];
      const colors = labels.map((label) => this.colorMap[label] || "#9E9E9E");

      this.estadoChartInstance = new Chart(this.$refs.estadoChart, {
        type: "doughnut",
        data: {
          labels,
          datasets: [{ data, backgroundColor: colors }],
        },
        options: this.getChartOptions(),
      });
      if (data.length === 0) {
        this.alertState = true;
      } else {
        this.alertState = false;
      }
    },

    renderLiqChart() {
      if (this.liqChartInstance) this.liqChartInstance.destroy();

      let labels = [];
      let data = [];

      const isLiq = this.liq;
      const useHours = this.showHours;

      if (isLiq && useHours) {
        labels = this.optionsLiqHours.labels;
        data = this.seriesLiqHours;
      } else if (isLiq) {
        labels = this.optionsLiqDays.labels;
        data = this.seriesLiqDays;
      } else if (useHours) {
        labels = this.optionsLiqHours.labels;
        data = this.seriesAutHours;
      } else {
        labels = this.optionsLiqDays.labels;
        data = this.seriesAutDays;
      }

      const colors = labels.map((label) => this.colorMap[label] || "#9E9E9E");

      this.liqChartInstance = new Chart(this.$refs.liqChart, {
        type: "doughnut",
        data: {
          labels,
          datasets: [
            {
              data,
              backgroundColor: colors,
            },
          ],
        },
        options: this.getChartOptions(),
      });
      if (data.length === 0) {
        this.alertLiq = true;
      } else {
        this.alertLiq = false;
      }
    },

    getChartOptions() {
      return {
        responsive: true,
        legend: {
          position: "right",
          labels: {
            fontColor: "#333",
            boxWidth: 10,
            usePointStyle: true,
            padding: 15,
          },
        },
        plugins: {
          datalabels: {
            formatter: (value, context) => {
              const total = context.chart.data.datasets[0].data.reduce(
                (a, b) => a + b,
                0
              );
              const percentage = total ? (value / total) * 100 : 0;
              return percentage >= 2 ? `${percentage.toFixed(1)}%` : null;
            },
            color: "#273746",
            font: {
              weight: "bold",
              size: 16,
            },
          },
        },
      };
    },
  },
};
</script>

<style scoped>
.card-title {
  height: 55px !important;
}
.card-title:hover {
  color: #39537a !important;
}
.graf1 {
  margin-top: 40px;
}
.card-estado,
.card-grafLiq {
  width: 800px !important;
  height: 600px !important;
  border-radius: 20px !important;
}
.col-loading-md {
  display: none;
}
.sumaHoras {
  display: inline-flex;
}

/* Responsive */
@media only screen and (max-width: 1800px) {
  .card-estado,
  .card-grafLiq {
    width: 750px !important;
    height: 600px !important;
  }
}

@media only screen and (max-width: 1500px) {
  .card-estado,
  .card-grafLiq {
    width: 650px !important;
    height: 500px !important;
  }
}

@media only screen and (max-width: 1200px) {
  .card-estado,
  .card-grafLiq {
    width: 500px !important;
    height: 500px !important;
  }
  .graf1 {
    width: 500px !important;
    height: 300px !important;
  }
}
@media only screen and (max-width: 500px) {
  .card-estado,
  .card-grafLiq {
    width: 500px !important;
    height: 500px !important;
  }
  .graf1 {
    margin: auto;
    width: 370px !important;
    height: 250px !important;
  }
}
</style>
